import { LoginProvider } from "./LoginContext";
import { AuthProvider } from "./AuthContext";
import { ModelProvider } from "./ModelContext";
import { NoticeDataProvider } from "./NoticeDataContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-tw";

export default function AllContextProviders({ children }) {
  return (
    <LoginProvider>
      <AuthProvider>
        <ModelProvider>
          <NoticeDataProvider>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={"zh-tw"}
              localeText={{ cancelButtonLabel: "取消", okButtonLabel: "確認" }}
            >
              {children}
            </LocalizationProvider>
          </NoticeDataProvider>
        </ModelProvider>
      </AuthProvider>
    </LoginProvider>
  );
}
